/**
 * The tag the frontend alert rules exclude on, so a slot's own failure lands in
 * Sentry without paging the channel that watches the product.
 */
export const AREA_TAG = { area: 'apps' };
